<template>
  <div id="EvaluationList">
    <div class="list_view list_flex">
      <a-menu style="width: 200px" mode="vertical" :selectedKeys="defaultData" @click="handleClick">
        <a-menu-item key="1">
          <router-link to="/dataCenter/dataSummary">校园数据概况</router-link>
        </a-menu-item>
        <a-menu-item key="2">
          <a v-if="userinfo && userinfo.role_id !== 1">校园数据管理</a>
          <router-link v-else to="/dataCenter/dataManagement">校园数据管理</router-link>
        </a-menu-item>
        <a-menu-item key="3" v-if="userinfo && userinfo.role_id === 1 && userinfo.CRISIS_LIMIT">
          <router-link to="/dataCenter/crisisEventEscalation">危机事件上报</router-link>
        </a-menu-item>
      </a-menu>
      <div class="list_con">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'List',
    data () {
      return {
        defaultData: ['1'],
        userinfo: null
      }
    },
    methods: {
      handleClick({key}) {
        if (this.userinfo.role_id === 1) {
           this.defaultData = [key]
        } else {
           if (parseInt(key) !== 1) {
            this.$message.warning('该功能尚未开通，敬请期待！')
          }
        }
      }
    },
    mounted () {
      this.userinfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }
  }
</script>

<style>
  #EvaluationList {
    width: 100%;
    height: 100%;
  }
  #EvaluationList .list_flex {
    display: flex;
  }
  #EvaluationList .list_view {
    width: 100%;
  }
  #EvaluationList .list_view .list_con {
    flex: 1;
    padding: 32px 0px 0px 24px;
    box-sizing: border-box;
  }
  .ant-menu {
    background-color: transparent;
    padding-top: 28px;
  }
  .ant-menu-vertical {
    border: none;
  }
  .ant-menu-item:hover {
    background: #F5F5F5!important;
  }
  .ant-menu-item:hover>a, .ant-menu-item-selected > a  {
    color: #25B864;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: transparent;
  }
  .ant-menu-submenu, .ant-menu-submenu div {
    height: 5px!important;
    line-height: 0px!important;
    margin-bottom: 13px;
  }
  .ant-menu-submenu span {
    display: inline-block;
    width: 25px;
    height: 1px;
    background: #E8E8E8;
  }
  .ant-menu-submenu i {
    display: none;
  }
  .ant-progress-status-success .ant-progress-bg {
    background: #25B864;
  }
  .ant-progress-status-success .ant-progress-text {
    color: #25B864;
  }
  .ant-tabs-ink-bar {
    background: #51BF94
  }
</style>
